import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../../service/user.service';
import { TchekOldService } from '../../service/tchek-old.service';
import { Tchek } from '../../model/tchek';
import { NotificationService } from '../../service/notification.service';
import { AuthService } from '../../service/auth.service';
import { TraceService } from '../../service/trace.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
import 'parse';
import * as $ from 'jquery';

const parse: typeof Parse = require('parse');
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {
  newTcheks = Array<Tchek>();
  statusIsOn = false;
  currentUrl = '';
  router: Router;
  isSuperAdmin = false;
  isAdmin = false;
  page: string;
  companyname: string;
  currentUser: string = '';
  constructor(
    private readonly _route: ActivatedRoute,
    private auth: AuthService,
    public _userService: UserService,
    private _tchekService: TchekOldService,
    private _traceService: TraceService,
    private _notificationService: NotificationService,
    private _location: Location,
    private _router: Router
  ) {
    if (parse.User.current()) {
      this.isAdmin = parse.User.current().get('isAdmin');
      this.companyname = parse.User.current().get('companyPtr').get('identifier');
    }
  }

  ngOnInit() {
    $(window).on('scroll', () => {
      $("#subMenue").removeClass('is-active')
    });

    this._router.events.pipe(filter(v => v instanceof NavigationEnd)).subscribe((data: NavigationEnd) => this.page = data.url);
    if (parse.User.current()) {
      this.companyname = parse.User.current().get('companyPtr').get('identifier');
      this.currentUser = parse.User.current().get('username');
    }
    if (parse.User.current() && parse.User.current().get('isSuperAdmin')) {
      this.isSuperAdmin = true;
    }
    this._notificationService.currentNewTcheks.subscribe(
      newTcheks => (this.newTcheks = newTcheks)
    );

    this._notificationService.currentStatus.subscribe(status => {
      this.statusIsOn = status;
    });

  }


  logout() {
    this.auth
      .logout()
      .subscribe(result => this._router.navigate(['/user/signin']));
    window.location.reload();
  }

  back() {
    this._location.back();
  }

  traceAssistance() {
    this._traceService.saveTrace(null, 'go to Assistance view');
  }

  traceSearch() {
    this._traceService.saveTrace(null, 'go to Search view');
  }

  traceHelp() {
    this._traceService.saveTrace(null, 'go to Help view');
  }

  traceParams() {
    this._traceService.saveTrace(null, 'go to Params view');
  }

}



// WEBPACK FOOTER //
// ./src/app/element/header/header.component.ts